import { Button, Divider, IconButton, List, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText, ListSubheader } from "@material-ui/core";
import React, { useMemo } from "react";
import { ChatAvatar } from "../../../../digitalArena/modules/ChatModule/components/ChatAvatar";
import { combineProps } from "../../../../helpers/objectHelper";
import { formatTime } from "../../../../helpers/time.helper";

import ChatBubbleIcon from "@material-ui/icons/ChatBubble";
import VideocamIcon from "@material-ui/icons/Videocam";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";

export const VisitorHistoryList = (props) => {
  const { orderList, visited, connectionList, exhibitorsHosts, clientKey } = props;
  const historicalVisitors = useMemo(() => {
    return visited.filter((v) => {
      const order = orderList.find((o) => o.badgeNo == v.badgeNo);
      if (order && order.anonymous != true) return { ...order, ...v };
    });
  }, [visited]);

  return (
    <List style={{ overflowY: "auto" }}>
      {historicalVisitors
        .filter((v) => v.badgeNo != clientKey)
        .map((v, i) => {
          return (
            <React.Fragment key={i}>
              <ListItem style={{ paddingRight: 20 }}>
                <ListItemAvatar>
                  <ChatAvatar
                    {...combineProps([
                      props,
                      {
                        connectionList,
                        orderList,
                        primaryColor: "#e4e6eb",
                        secondaryColor: "#fff",
                        target: v.badgeNo,
                      },
                    ])}
                  ></ChatAvatar>
                </ListItemAvatar>
                <ListItemText
                  primary={
                    <div style={{ display: "flex", width: "100%" }}>
                      <span className="ellipsis" style={{ width: "50%" }}>
                        {" "}
                        {v.fullName}
                      </span>
                      <span style={{ width: "50%", textAlign: "right", marginLeft: 10, opacity: 0.7 }}>{formatTime(new Date(v.lastVisit))}</span>
                    </div>
                  }
                  secondary={v.companyName}
                />
                <ListItemSecondaryAction></ListItemSecondaryAction>
              </ListItem>
              <Divider variant="inset" component="li" />
            </React.Fragment>
          );
        })}
    </List>
  );
};
